/*
 * @Date: 2023-10-30 19:39:32
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-11-17 15:17:07
 * @FilePath: /Client/src/util/useChannelName.ts
 * @Description:
 */
export default (to:any, from:any) => {
  if (from.query?.channel && !to.query?.channel) {
    to.query.channel = String(from.query.channel ?? '')
    return to
  }

  if (from.query?.code && !to.query?.code) {
    to.query.code = String(from.query.code ?? '')
    return to
  }

  if (from.query?.channel_group && !to.query?.channel_group) {
    to.query.channel_group = String(from.query.channel_group ?? '')
    return to
  }
  if (from.query?.spm && !to.query?.spm) {
    to.query.spm = from.query.spm
    return to
  }
  if (from.query?.utm_source && !to.query?.utm_source) {
    to.query.utm_source = from.query.utm_source
    return to
  }
  if (from.query?.utm_medium && !to.query?.utm_medium) {
    to.query.utm_medium = from.query.utm_medium
    return to
  }
  if (from.query?.utm_campaign && !to.query?.utm_campaign) {
    to.query.utm_campaign = from.query.utm_campaign
    return to
  }
  if (from.query?.utm_content && !to.query?.utm_content) {
    to.query.utm_content = from.query.utm_content
    return to
  }

  if (from.query?.channelRedirect && !to.query?.channelRedirect && ['/login', '/signup', '/login_h5', '/signup_h5'].includes(to.path)) {
    to.query.channelRedirect = from.query?.channelRedirect
    return to
  }
  if (from.query?.redirect && !to.query?.redirect && ['/login', '/signup', '/login_h5', '/signup_h5'].includes(to.path)) {
    to.query.redirect = from.query?.redirect
    return to
  }
}
